import Alpine from "alpinejs";

Alpine.data("showButton", () => ({
    show: false,
    button: {
        ["@click"]() {
            this.show = true;
            setTimeout(() => {
                this.$refs.hider.remove();
            }, 100);
        },
    },
    icon: {
        [":class"]() {
            return this.show && "rotate-45";
        },
    },
}));
